module.exports = __webpack_public_path__ + "img/1-13-3.77c3e1ee.png";